module.exports = __webpack_public_path__ + "static/media/doctor-female.59b56ef6.png";